import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import { useMemo } from 'react';
import { SubmissionScore } from '@module/assignment';
import styled from '@xstyled/styled-components';
import { Radio, Space } from 'antd';
import { MathEnabledTextComponent, styleVariables } from '@lib/common';
import { GradingBaseAnswer } from './base-question.component';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledAnswerContainer = styled(Space)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var StyledAnswerItemLayout = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n"])));
var StyledAnswerRadio = styled(Radio)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  flex: 1;\n  cursor: default;\n"])));
var StyledAnswerText = styled(MathEnabledTextComponent)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-style: normal;\n  font-weight: ", ";\n  font-size: 14px;\n  line-height: 24px;\n  color: ", ";\n\n  p {\n    margin-bottom: 0;\n  }\n"])), styleVariables.font.fontWeightStrong, styleVariables.colors.gray11);

var isAnswerCorrect = function isAnswerCorrect(correctAnswers, answerId) {
  return correctAnswers.some(function (c) {
    return c.answerId === answerId;
  });
};

var isAnswerSelected = function isAnswerSelected(selectedAnswerId, answerId) {
  return selectedAnswerId === answerId;
};

var formatAnswerDescription = function formatAnswerDescription(description, isCorrect, correctAnswerLabel) {
  if (!isCorrect) {
    return description;
  }

  return "".concat(description, " <label style=\"color: ").concat(styleVariables.colors.green1, "\">(").concat(correctAnswerLabel, ")</label>");
};

var isQuestionGraded = function isQuestionGraded(answer) {
  return answer.score !== SubmissionScore["default"].value;
};

export var GradingSingleChoiceAnswer = function GradingSingleChoiceAnswer(_ref) {
  var _answer$value;

  var question = _ref.question,
      isSkipped = _ref.isSkipped,
      answer = _ref.answer,
      label = _ref.label,
      isCorrect = _ref.isCorrect,
      submitGradeAnswer = _ref.submitGradeAnswer,
      disabled = _ref.disabled,
      hasAnswer = _ref.hasAnswer,
      index = _ref.index,
      scoreValue = _ref.value,
      isResponderView = _ref.isResponderView,
      isShowingExplanation = _ref.isShowingExplanation;
  var hasCorrectAnswer = useMemo(function () {
    return question.correctAnswers.length > 0;
  }, [question.correctAnswers.length]);
  var selectedAnswerId = answer === null || answer === void 0 ? void 0 : (_answer$value = answer.value) === null || _answer$value === void 0 ? void 0 : _answer$value.answerId;

  var renderAnswerItem = function renderAnswerItem(answerId, description, isCorrect, isSelected, key) {
    var formattedDescription = formatAnswerDescription(description, isCorrect, label.correctAnswer);
    return /*#__PURE__*/_jsx(StyledAnswerItemLayout, {
      children: /*#__PURE__*/_jsx(StyledAnswerRadio, {
        value: answerId,
        checked: isSelected,
        disabled: true,
        children: /*#__PURE__*/_jsx(StyledAnswerText, {
          value: formattedDescription
        })
      })
    }, key);
  };

  var renderAnswers = function renderAnswers() {
    if (isSkipped) {
      return question.answers.map(function (a, index) {
        var isCorrect = isAnswerCorrect(question.correctAnswers, a.id.toString());
        return renderAnswerItem(a.id.toString(), a.description, isCorrect, false, index);
      });
    }

    return question.answers.map(function (a, index) {
      var isSelected = isAnswerSelected(selectedAnswerId, a.id.toString());
      var isCorrect = isAnswerCorrect(question.correctAnswers, a.id.toString());
      return renderAnswerItem(a.id.toString(), a.description, isCorrect, isSelected, index);
    });
  };

  return /*#__PURE__*/_jsx(GradingBaseAnswer, {
    question: question,
    isSkipped: isSkipped,
    isCorrect: isCorrect,
    hasAnswer: hasAnswer,
    label: label,
    index: index,
    submitGradeAnswer: submitGradeAnswer,
    disabled: disabled,
    value: scoreValue,
    hasCorrectAnswer: hasCorrectAnswer,
    isAllQuestionAnswersGraded: isQuestionGraded(answer),
    isResponderView: isResponderView,
    isShowingExplanation: isShowingExplanation,
    children: /*#__PURE__*/_jsx(StyledAnswerContainer, {
      direction: "vertical",
      children: renderAnswers()
    })
  });
};